const KNOWLEDGE_ID_PATTERN = /\b(?:KB|SRC|MAP|INB)-\d{6}\b/g;

export function extractKnowledgeIds(text: string): string[] {
  return [...new Set(text.toUpperCase().match(KNOWLEDGE_ID_PATTERN) ?? [])];
}

export function normalizeKnowledgeId(value: string): string {
  return value.trim().toUpperCase();
}

export function isKnowledgeId(value: string): boolean {
  return /^(?:KB|SRC|MAP|INB)-\d{6}$/.test(normalizeKnowledgeId(value));
}
